import { z } from 'zod';

export const fixSchema = z.object({
  _id: z.string(),
  serialNumber: z.string(),
  householdNumber: z.string(),
  category: z.union([
    z.object({
      name: z.enum(['家中設備', '其他']),
    }),
    z.object({
      name: z.literal('公共設備'),
      communityDeviceId: z.string(),
    }),
  ]),
  title: z.string(),
  content: z.string(),
  bookingTime: z.string(),
  image: z.object({ name: z.string(), path: z.string() }).nullable(),
  status: z.enum(['未處理', '已安排', '處理中', '已處理']),
  createdTime: z.string(),
  updatedTime: z.string(),
});

export type Fix = z.infer<typeof fixSchema>;

export const uploadFixSchema = fixSchema.omit({
  _id: true,
  serialNumber: true,
  status: true,
  createdTime: true,
  updatedTime: true,
});

export type UploadFix = z.infer<typeof uploadFixSchema>;
